import { Controller } from "stimulus"
import simpleParallax from 'simple-parallax-js';

export default class extends Controller {
  static targets = [ "image" ]

  connect() {
    this.imageTarget.style.bottom = this.imageTarget.dataset.offset
    const image = this.imageTarget
    new simpleParallax(image, {
      overflow: true
    });
  }
}
